import { GET_ALL_NOTES_SUCCESS } from '../actions/types';

const initialState = {
    notes: [],
    totalPages: 0,
    currentPage: 1,
    totalNotes: 0,
    loading: true
};

export default function notesReducer(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case GET_ALL_NOTES_SUCCESS:
            return {
                ...state,
                notes: payload.notes || [],
                totalPages: payload.totalPages || 1,
                currentPage: payload.currentPage || 1,
                totalNotes: payload.totalNotes || 0,
                loading: false
            };
        default:
            return state;
    }
}